import { b2x } from '@b2x/react/src';

export type ContainerProps = b2x.ContainerProps;

export const Container = (props: ContainerProps) => <b2x.Container fluid="always" {...props} />;
